import { render } from "./TenderManagement.vue?vue&type=template&id=0027e465&scoped=true"
import script from "./TenderManagement.vue?vue&type=script&lang=js"
export * from "./TenderManagement.vue?vue&type=script&lang=js"

import "./TenderManagement.vue?vue&type=style&index=0&id=0027e465&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0027e465"]])

export default __exports__